import { pageCustomerDirectories, pageDirectories } from '@/constant/route';
import { screenSize } from '@/styles/styles';
import {
    FilePen,
    Folder,
    Search,
    Settings,
    ChartNoAxesCombined,
    List,
} from 'lucide-react';
import { CustomerNavBar } from './type';

export const mediaBreakpoints = screenSize.lg;

export const arrHeaderNavbar: CustomerNavBar[] = [
    {
        langResource: 'Sidebar_IntroAndGuide',
        icon: Settings,
        href: pageCustomerDirectories.Introduction,
    },
    {
        langResource: 'Sidebar_DossierLookup',
        icon: Search,
        href: pageCustomerDirectories.LookUpDossier,
    },
    {
        langResource: 'Sidebar_PublicStatistics',
        icon: ChartNoAxesCombined,
        href: pageCustomerDirectories.PublicStatistics,
    },
];
export const arrSidebarNavbar: CustomerNavBar[] = [
    {
        langResource: 'Sidebar_DossierList',
        icon: Folder,
        href: pageCustomerDirectories.ListDossierCust,
    },
    {
        langResource: 'Sidebar_DocumentManagement',
        icon: FilePen,
        href: pageCustomerDirectories.Paper,
    },
];
